// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"56c84f7c","877":"4f96f3b8"}[chunkId] + ".chunk.css";
};